import { Navigate, Link } from 'react-router-dom';
import { useAdminAuth } from '@/hooks/useAdminAuth';
import { Card, CardContent, CardDescription, CardHeader, CardTitle } from '@/components/ui/card';
import { Loader2, Terminal, Zap } from 'lucide-react';

const pages = [
  {
    to: '/debug/backend',
    icon: Terminal,
    title: 'Backend Debug Console',
    description: 'Health checks, system info, run list, and direct execution against the backend API.',
  },
  {
    to: '/debug/execution',
    icon: Zap,
    title: 'Execution Debug',
    description: 'Create and execute runs end-to-end, inspect progress, events, and artifacts.',
  },
];

export default function DebugIndex() {
  const { isAdmin, loading } = useAdminAuth();

  if (loading) {
    return (
      <div className="min-h-screen flex items-center justify-center">
        <Loader2 className="w-8 h-8 animate-spin text-primary" />
      </div>
    );
  }

  if (!isAdmin) return <Navigate to="/dashboard" replace />;

  return (
    <div className="min-h-screen bg-background text-foreground p-6 max-w-4xl mx-auto space-y-6">
      <div>
        <h1 className="text-2xl font-bold tracking-tight">Debug Tools</h1>
        <p className="text-muted-foreground text-sm mt-1">Admin-only developer consoles</p>
      </div>

      <div className="grid gap-4 sm:grid-cols-2">
        {pages.map(({ to, icon: Icon, title, description }) => (
          <Link key={to} to={to} className="group">
            <Card className="h-full transition-colors border-border hover:border-primary/50 hover:bg-muted/40">
              <CardHeader className="pb-2">
                <CardTitle className="text-base flex items-center gap-2">
                  <Icon className="w-5 h-5 text-primary" />
                  {title}
                </CardTitle>
              </CardHeader>
              <CardContent>
                <CardDescription>{description}</CardDescription>
              </CardContent>
            </Card>
          </Link>
        ))}
      </div>
    </div>
  );
}
